import { Modelo } from '@ext/index';
import * as Types from './Curso.types';
import moment, { Moment } from 'moment';
import { Recurso } from '@/__env/lib/Cursos/Recursos';
import { Pregunta } from '@/__env/lib/Cursos/Preguntas';
import { isArray } from 'util';
import { Resultado } from '@/__env/lib/Cursos/Resultado';
import { Participante } from '@/__env/lib/Cursos/Curso.nav';

export class ICurso extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Estado: Types.Estados = Types.Estados.Creado;
    public Tipo: Types.Tipos = Types.Tipos.Ventas;
    public Titulo: string = '';
    public Descripcion: string = '';
    public Link: string = '';

    public Preguntas: Pregunta[] = [];
    public Recursos: Recurso[] = [];
    public Participantes: Participante[] = [];
    public Estadistica : IEstadistica = new IEstadistica();


    public getJson(): any
    {
        let json: any = {};

        json.estado = this.Estado.Id;
        json.tipo = this.Tipo.Id;
        json.titulo = this.Titulo;
        json.descripcion = this.Descripcion;

        json.recursos = this.Recursos.map( x => x.getJson() );
        json.preguntas = this.Preguntas.map( x => x.getJson() );

        return json;
    }


    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Estado = Types.Estados.toTipo( this.Json.estado );
        this.Tipo = Types.Tipos.toTipo( this.Json.tipo );
        this.Titulo = !this.Json.titulo ? '' : this.Json.titulo;
        this.Descripcion = !this.Json.descripcion ? '' : this.Json.descripcion;
        this.Link = !this.Json.link ? '' : this.Json.link;

        if ( isArray( this.Json.preguntas ) )
        {
            for ( let e of this.Json.preguntas )
            {
                this.Preguntas.add( new Pregunta( e ) );
            }
        }

        if ( isArray( this.Json.recursos ) )
        {
            for ( let e of this.Json.recursos )
            {
                this.Recursos.add( new Recurso( e ) );
            }
        }


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: ICurso )
    {
        this.Model = Model;
    }

    public Model: ICurso;
}

export class IParticipante extends Modelo
{
    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Curso: number = 0;
    public Id: number = 0;
    public Nombre: string;
    public Apellido: string;
    public Usuario: string = '';
    public Email: string = '';

    public Resultado: Resultado;

    public Finalizado: boolean  = false;
    public Calificacion: number = 0;

    public get Iniciales(): string
    {
        let ini = "";

        if ( this.Apellido && this.Nombre )
        {
            ini += this.Nombre.substring( 0, 1 );
            ini += this.Apellido.substring( 0, 1 );
        } else if ( this.Nombre )
        {
            ini = this.Nombre.substring( 0, 2 );
        }
        else
        {
            ini = this.Usuario.substring( 0, 2 );
        }

        return ini.toUpperCase();

    }

    public set(): boolean
    {

        this.Curso = !this.Json.curso ? 0 : this.Json.curso;
        this.Id = !this.Json.usuario.id ? 0 : this.Json.usuario.id;
        this.Nombre = !this.Json.usuario.nombre ? '' : this.Json.usuario.nombre;
        this.Apellido = !this.Json.usuario.apellido ? '' : this.Json.usuario.apellido;
        this.Usuario = !this.Json.usuario.usuario ? '' : this.Json.usuario.usuario;
        this.Email = !this.Json.usuario.email ? '' : this.Json.usuario.email;

        this.Finalizado = this.Json.finalizado == 'S';
        this.Calificacion = this.Json.calificacion;

        this.Existe = true;
        return this.Existe;
    }



    public get Vista(): Vista2
    {
        return new Vista2( this );

    }
}

class Vista2
{
    constructor( Model: IParticipante )
    {
        this.Model = Model;
    }

    public Model: IParticipante;
    public get Resultado(): string
    {
        if ( this.Model.Calificacion <= 40 )
            return 'desaprobado';
        else if ( this.Model.Calificacion <= 70 )
            return 'aceptable';
        else if ( this.Model.Calificacion < 90 )
            return 'aprobado';
        else if ( this.Model.Calificacion >= 90 )
            return 'perfecto';
    }

    public get Color(): string
    {
        if ( this.Model.Calificacion <= 40 )
            return 'error';
        else if ( this.Model.Calificacion <= 70 )
            return 'light-blue';
        else if ( this.Model.Calificacion < 90 )
            return 'light-blue';
        else if ( this.Model.Calificacion >= 90 )
            return 'success';
    }
}


export class IEstadistica extends Modelo
{
    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Participantes: number = 0;
    public Promedio: number = 0;
    public Correctas: number = 0;
    public Incorrectas: number = 0;
    public NoContestadas: number = 0;
    public Contestadas: number = 0;
    public Aprobados: number = 0;
    public Desaprobados: number = 0;

    public set(): boolean
    {

        this.Participantes = this.Json.participantes;
        this.Promedio = this.Json.promedio;
        this.Correctas = this.Json.correctas;
        this.Incorrectas = this.Json.incorrectas;
        this.NoContestadas = this.Json.no_contestadas;
        this.Contestadas = this.Json.contestadas;
        this.Aprobados = this.Json.aprobados;
        this.Desaprobados = this.Json.desaprobados;

        this.Existe = true;
        return this.Existe;
    }




}